import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import './style/Header.css';

/**
 *
 * @return {object}
 */
export default function ButtonAppBar() {
  return (
    <AppBar className='barContainer' position='sticky' elevation={0}>
      <Toolbar className='bar' sx={{height: '15vh'}}>
        <Typography className="header" variant="h3"
          component="div" sx={{flexGrow: 1, m: '2vw'}}>
          <a className="logo" href="#/">Anika Mahajan</a>
        </Typography>
        <Button className="link" href="#/"
          rel="noopener noreferrer" color="inherit">
          <Typography className="tab" variant="h4"
            component="div" sx={{flexGrow: 1, m: '1vw 0.5vw 0.5vw 0.5vw',
              fontSize: '2.25vw'}}>
              &nbsp;&nbsp;ABOUT&nbsp;&nbsp;
          </Typography>
        </Button>
        <Button className="link" href="#/research"
          rel="noopener noreferrer" color="inherit">
          <Typography className="tab" variant="h4"
            component="div" sx={{flexGrow: 1, m: '1vw 0.5vw 0.5vw 0.5vw',
              fontSize: '2.25vw'}}>
            RESEARCH
          </Typography>
        </Button>
        <Button className="link" href="#/design"
          rel="noopener noreferrer" color="inherit">
          <Typography className="tab" variant="h4"
            component="div" sx={{flexGrow: 1, m: '1vw 2vw 0.5vw 0.5vw',
              fontSize: '2.25vw'}}>
            &nbsp;&nbsp;&nbsp;DESIGN
          </Typography>
        </Button>
      </Toolbar>
    </AppBar>
  );
}
